/*
 * @Author: your name
 * @Date: 2020-12-03 18:09:26
 * @LastEditTime: 2021-04-07 09:07:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Input\Motion.js
 */

import * as THREE from 'three'
import { InputBase } from './InputBase'

export class GravitySensor extends InputBase {
  constructor () {
    super()

    this.targetAngle = new THREE.Vector3()
    this.readly = false

    this.bindEvent = this.onOrientationChange.bind(this)
    this.bindChange = this.onScreenOrientationChangeEvent.bind(this)

    this.ori = 0
  }

  init (setting) {
    const self = this
    if (window.DeviceOrientationEvent !== undefined && typeof window.DeviceOrientationEvent.requestPermission === 'function') {
      try {
        self.addListener()
      } catch (error) {
        console.error('THREE.DeviceOrientationControls: Unable to use DeviceOrientation API:', error)
      }
    } else {
      self.addListener()
    }
  }

  addListener () {
    window.addEventListener('deviceorientation', this.bindEvent, false)
    window.addEventListener('orientationchange', this.bindChange, false)
    this.readly = true
  }

  depose () {
    window.removeEventListener('deviceorientation', this.bindEvent, false)
    window.removeEventListener('orientationchange', this.bindChange, false)
    this.readly = false
  }

  setObjectQuaternion (quaternion, alpha, beta, gamma, orient) {
    const euler = new THREE.Euler()
    const q1 = new THREE.Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)) // - PI/2 around the x-axis

    euler.set(beta, alpha, -gamma, 'YXZ') // 'ZXY' for the device, but 'YXZ' for us
    quaternion.setFromEuler(euler) // orient the device
    quaternion.multiply(q1) // camera looks out the back of the device, not the top
    quaternion.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 0, 1), -orient)) // adjust for screen orientation
  }

  /**
   * 在
   * @param {DeviceOrientationEvent} event 重力感应器事件
   */
  onOrientationChange (event) {
    // console.log(event.alpha.toFixed(0) + ' : ' + event.beta.toFixed(0) + ' : ' + event.gamma.toFixed(0))
    this.targetAngle.x = THREE.MathUtils.degToRad(event.alpha)
    this.targetAngle.y = THREE.MathUtils.degToRad(event.beta)
    this.targetAngle.z = THREE.MathUtils.degToRad(event.gamma)
  }

  /**
   * 监听重力变换事件
   * @param {DeviceOrientationEvent} event 重力感应器事件
   */
  onScreenOrientationChangeEvent () {
    this.ori = window.orientation || 0
  }

  camUpdate () {
    if (!this.readly) {
      return
    }
    try {
      const q0 = new THREE.Quaternion()
      this.setObjectQuaternion(q0, this.targetAngle.x, this.targetAngle.y, this.targetAngle.z, this.ori)
      const forword = new THREE.Vector3(0, 0, 1).applyQuaternion(q0)
      // console.log(forword.toArray().map(i => i.toFixed(0)))
      // console.log(new THREE.Euler().setFromQuaternion(q0).toVector3().multiplyScalar(180 / Math.PI).toArray().map(i => i.toFixed(0)))
      if (forword.y >= 1) {
        this.dlat = 0 - this.cam.lat
        this.dlon = 0 - this.cam.lon
        return
      }

      this.dlat = (-Math.asin(forword.y) * 180 / Math.PI) - this.cam.lat
      const d = forword.x > 0 ? 1 : -1
      this.dlon = d * ((Math.asin(forword.z / (Math.sqrt(1 - Math.pow(Math.abs(forword.y), 2)))) / Math.PI) * 180 + 90) - this.cam.lon
      this.activate = true

      this.dlat = Math.abs(this.dlat) < 1 ? 0 : this.dlat
      this.dlon = Math.abs(this.dlon) < 1 ? 0 : this.dlon
    } catch (e) {
      console.error(e)
    }
  }
}
